import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';

import {
  startAddWebsiteTestimonial,
  startEditWebsiteTestimonial,
  startRemoveWebsiteTestimonial,
} from 'store/actions/website';
import { ConfirmDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  avatar: {
    marginRight: theme.spacing.unit*2,
  },
  card: {
    marginTop: theme.spacing.unit*3,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
  },
  name: {
    marginRight: theme.spacing.unit*2,
  },
  rootContent: {
    backgroundColor: indigo[50],
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    flexGrow: 1,
    marginRight: theme.spacing.unit,
  },
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});

const validate = (testimonial) => {
  const errors = {};
  const requiredFields = [ 'title', 'name', 'location', 'description' ];
  requiredFields.forEach(field => {
    if (!testimonial[field]) {
      errors[field] = 'Required';
    }
  });

  const validation = { errors, isInvalid: !!Object.keys(errors).length };
  validation.validateField = function (field) {
      return this.errors[field];
  };

  return validation;
}

class TestimonialDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showValidation: false,
      showDelete: false,
    }
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { testimonial, handleClose, startRemoveWebsiteTestimonial } = this.props;

    startRemoveWebsiteTestimonial(testimonial.id)
      .then(() => handleClose());
  }

  render() {
    const {
      classes,
      testimonial,
      handleClose,
      handleChange,
      startAddWebsiteTestimonial,
      startEditWebsiteTestimonial,
    } = this.props;
    const { showDelete, showValidation, validation } = this.state;
    const type = testimonial.id === undefined ? "add" : "edit";

    return(
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Testimonial"
          contentText="This action will delete the testimonial. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        <Dialog
          maxWidth="md"
          open={testimonial === undefined ? false : true}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>
            <div className={classes.header}>
              <Avatar aria-label="Service" className={classes.avatar}>
                S
              </Avatar>
              <div>
                <Typography variant="subheading">
                  {type === "edit" ? "Edit Testimonial" : "Add Testimonial"}
                </Typography>
              </div>
            </div>
          </DialogTitle>
          <DialogContent classes={{root: classes.rootContent}}>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <div className={classes.row}>
                  <TextField
                    error={(showValidation && !!validation.validateField("title"))}
                    helperText={(showValidation && validation.validateField("title"))}
                    className={classes.title}
                    label="Title"
                    placeholder="Enter title"
                    margin="normal"
                    value={testimonial.title}
                    onChange={ event => {
                      if (showValidation) {
                        const validation = validate({ ...testimonial, title: event.target.value });
                        this.setState({
                          showValidation: true,
                          validation,
                        });
                      }

                      handleChange("title", event.target.value);
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={testimonial.show}
                        onChange={ event => handleChange("show", !testimonial.show)}
                      />
                    }
                    label="Show"
                  />
                </div>

                <div className={classes.row}>
                  <TextField
                    error={(showValidation && !!validation.validateField("name"))}
                    helperText={(showValidation && validation.validateField("name"))}
                    className={classes.name}
                    label="Name"
                    placeholder="Enter name"
                    margin="normal"
                    value={testimonial.name}
                    onChange={ event => {
                      if (showValidation) {
                        const validation = validate({ ...testimonial, name: event.target.value });
                        this.setState({
                          showValidation: true,
                          validation,
                        });
                      }
                      handleChange("name", event.target.value);
                    }}
                  />
                  <TextField
                    error={(showValidation && !!validation.validateField("location"))}
                    helperText={(showValidation && validation.validateField("location"))}
                    label="Location"
                    placeholder="Enter location"
                    margin="normal"
                    value={testimonial.location}
                    onChange={ event => {
                      if (showValidation) {
                        const validation = validate({ ...testimonial, location: event.target.value });
                        this.setState({
                          showValidation: true,
                          validation,
                        });
                      }
                      handleChange("location", event.target.value);
                    }}
                  />
                </div>
                <TextField
                  error={(showValidation && !!validation.validateField("description"))}
                  helperText={(showValidation && validation.validateField("description"))}
                  label="Description"
                  placeholder="Enter description"
                  multiline
                  rows="8"
                  margin="normal"
                  value={testimonial.description}
                  onChange={ event => {
                    if (showValidation) {
                      const validation = validate({ ...testimonial, description: event.target.value });
                      this.setState({
                        showValidation: true,
                        validation,
                      });
                    }
                    handleChange("description", event.target.value);
                  }}
                />
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={() => this.setState({ showDelete: true })}>
              Delete
            </Button>
            <div>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  const validation = validate(testimonial);
                  if (validation.isInvalid) {
                    this.setState({
                      showValidation: true,
                      validation,
                    });
                  } else {
                    if (type === "add") {
                      startAddWebsiteTestimonial(testimonial)
                        .then(() => handleClose());
                    } else {
                      const { id, ...updates } = testimonial;
                      startEditWebsiteTestimonial(id, updates)
                        .then(() => handleClose());
                    }
                  }

                }}
                color="primary">
                {type === "add" ? "Add" : "Done"}
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapDispatchToProps = {
  startAddWebsiteTestimonial,
  startEditWebsiteTestimonial,
  startRemoveWebsiteTestimonial,
};

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(TestimonialDialog)



// WEBPACK FOOTER //
// ./src/components/admin/Website/Dialogs/TestimonialDialog.jsx